import { useEffect, useState } from 'react'
import { Modal, Tabs, Typography } from 'antd'
import { LEGAL_TERMS_VERSION } from '../../constants/legal'
import { LEGAL_DOCS, LEGAL_DOC_TABS, LegalDocKey } from '../../constants/legalContent'

const { Title, Paragraph, Text } = Typography

interface LegalTermsModalProps {
  open: boolean
  onClose: () => void
  initialDocKey?: LegalDocKey
  legalTermsVersion?: string
}

export default function LegalTermsModal({
  open,
  onClose,
  initialDocKey = 'userAgreement',
  legalTermsVersion,
}: LegalTermsModalProps) {
  const [activeDocKey, setActiveDocKey] = useState<LegalDocKey>(initialDocKey)

  useEffect(() => {
    if (open) {
      setActiveDocKey(initialDocKey)
    }
  }, [open, initialDocKey])

  const currentVersion = legalTermsVersion || LEGAL_TERMS_VERSION

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={880}
      title="法律條款"
      destroyOnClose={false}
    >
      <Tabs
        activeKey={activeDocKey}
        onChange={(key) => setActiveDocKey(key as LegalDocKey)}
        items={LEGAL_DOC_TABS.map((tab) => {
          const doc = LEGAL_DOCS[tab.key]
          return {
            key: tab.key,
            label: tab.label,
            children: (
              <div style={{ maxHeight: '62vh', overflowY: 'auto', paddingRight: 8 }}>
                <Title level={4} style={{ marginBottom: 8 }}>
                  {doc.pageTitle}
                </Title>
                <Text type="secondary">版本：{currentVersion}</Text>
                <br />
                <Text type="secondary">生效日期：{doc.effectiveDate}</Text>

                <div style={{ marginTop: 20 }}>
                  {doc.sections.map((section) => (
                    <div key={section.title} style={{ marginBottom: 20 }}>
                      <Title level={5} style={{ marginBottom: 8 }}>
                        {section.title}
                      </Title>
                      {section.paragraphs.map((item, index) => (
                        <Paragraph key={`${section.title}-${index}`} style={{ marginBottom: 8 }}>
                          {item}
                        </Paragraph>
                      ))}
                    </div>
                  ))}
                </div>

                <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                  如有疑問，請聯絡：admin@kyren.io
                </Paragraph>
              </div>
            ),
          }
        })}
      />
    </Modal>
  )
}
